import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {LoginSchema} from "../types/loginSchema";
import {loginByUsername} from "../service/login-by-user-name/loginByUsername";
import {useAppDispatch} from "../../../common/hook";


interface LoginState extends LoginSchema {
    status: 'idle' | 'pending' | 'fulfilled' | 'rejected';
    email: string;
    success: boolean
    password: string;
    isLoading: boolean;
    error: { error: string; success: boolean; }
}

const initialState: LoginState = {
    status: 'idle',
    email: "",
    password: "",
    success: false,
    isLoading: false,
    error: {error: '', success: true},
};


export const loginSlice = createSlice({
    name: "login",
    initialState,
    reducers: {
        setUsername: (state, action: PayloadAction<string>) => {
            state.email = action.payload;
        },
        setPassword: (state, action: PayloadAction<string>) => {
            state.password = action.payload;
        },
        setError: (state, action: PayloadAction<{ success: boolean; error: string; }>) => {
            state.error = action.payload;

        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loginByUsername.pending, (state) => {
                state.status = 'pending';
                state.error = { error: '', success: true };
                state.isLoading = true;
            })
            .addCase(loginByUsername.fulfilled, (state) => {
                if (state.success) {
                    state.status = 'fulfilled';
                }
                state.isLoading = false;
            })
            .addCase(loginByUsername.rejected, (state, action) => {
                state.status = 'rejected';
                state.isLoading = false;
            });

    },
});

export const {actions: loginActions} = loginSlice;
export const {reducer: loginReducer} = loginSlice;